export default {"src":"/_next/static/media/founders-badge.3ae57876.svg","height":158,"width":158,"blurWidth":0,"blurHeight":0};